export const blockIconsSocialHistoryEdu = (
	<span className='material-symbols-outlined'>history_edu</span>
);
